<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('income_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
            <router-link to="/income" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <router-link to="/import/income" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-file-excel-o" aria-hidden="true"></i> {{$t('import')}}</router-link>
            <div class="pull-right">
                <div class="form-inline">
                    <input type="date" class="form-control form-control-sm max-width" v-model="query.FromDate" @change="toList"/>
                    <span style="padding: 0 3px;"></span>
                    <input type="date" class="form-control form-control-sm max-width" v-model="query.ToDate" @change="toList"/>
                    <span style="padding: 0 3px;"></span>
                    <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('sale_invoice_no')" v-model="query.Text" @keypress.enter="toList"/>
                    <span style="padding: 0 3px;"></span>
                    <button type="button" class="btn btn-default btn-sm" style="width: 30px;"><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" style="width: 30px;" @click="toList"><i class="fa fa-search" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card n_card">
                <div class="card-body">
                    <table class="table table-sm no-bor">
                        <thead>
                        <tr>
                            <th>{{ $t('no') }}</th>
                            <th>{{ $t('receipt_no') }}</th>
                            <th>{{ $t('date') }}</th>
                            <th>{{ $t('type') }}</th>
                            <th>{{ $t('income_type') }}</th>
                            <th>{{ $t('description') }}</th>
                            <th>{{ $t('invoice_no') }}</th>
                            <th class="text-right">{{$t('amount')}}</th>
                            <th>{{$t('status')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td>{{index+1}}</td>
                                <td>
                                    <router-link :to="{ name: 'sale_receipt_preview', params:{ id:ret.Id }}">{{ret.Num}}</router-link>
                                </td>
                                <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                <td>{{ret.DocSource}}</td>
                                <td>{{ret.AccountName}}</td>
                                <td>{{ret.Description}}</td>
                                <td>
                                    <router-link v-if="ret.IsLinked" :to="{ name:'sale_invoice_view',params:{id:ret.InvoiceId}}">{{ret.InvoiceNum}}</router-link>
                                    <span v-else>{{ret.InvoiceNum}}</span>
                                </td>
                                <td class="text-right">{{$money(ret.Amount)}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="7"></th>
                                <th class="text-right">{{$money(summary.Total)}}</th>
                                <th></th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="box-page">
                <b-pagination size="sm" :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')" hide-goto-end-buttons/>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    export default {
        data: function(){
            return {
                query:{
                    Text: '',
                    FromDate: moment().format('MM/1/YYYY'),
                    ToDate: moment().endOf('month').format('MM/DD/YYYY'),
                    Page: 1,
                    Total: 0,
                    Limit: 25
                },
                records:[],
                summary: {
                    Total: 0
                }
            }
        },
        created: function(){
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('sale/receipts').then((res) => {
                    if(this.$isValid(res)){
                        this.records = res.data.Data;
                        this.calculate();
                    }
                }).finally(function() { loading.hide(); });
            },
            calculate(){
                let total = 0;
                this.records.forEach(item => {
                    total += item.Amount;
                });
                this.summary.Total = total;
            }
        }
    }
</script>